// eslint-disable-next-line @nx/enforce-module-boundaries
import { PREPAID_CARD_NUMBER_LENGTH } from '@ocx/feat-add-payment-instrument';

import { maxLengthParser, onlyNumbersParser } from '../../../lib/form/utils';

export const parseCardNumber = (value: string) => maxLengthParser(onlyNumbersParser(value), PREPAID_CARD_NUMBER_LENGTH);
export const formatCardNumber = (value: string) => (value.match(/[\d]{1,4}/g) || []).join(' ');
